// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6y870","left":"styles_left__2QqWU"};